import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, retry } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseHttpService {

  protected constructor(protected http: HttpClient) { }

  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders, responseType?: any): Observable<any> {
    return this.http.get<T>(url, { headers, params, responseType });
  }

  post<T>(url: string, body: any, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    return this.http.post<T>(url, body, { headers, params });
  }

  patch<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.patch<T>(url, body, { headers });
  }

  put<T>(url: string, body: any, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    return this.http.put<T>(url, body, { headers, params });
  }

  delete<T>(url: string, body?: any, headers?: HttpHeaders, params?: HttpParams): Observable<T> {
    return this.http.delete<T>(url, { body, headers, params });
  }

}